import { BrandingColors } from './branding-types';

// shepherdColors are the named colors from the Shepherd brand guide (shepherd-brand-guide.pdf, "Color" section).
//
// Primary palette: Blue, Navy, Sky, and Sky 20%.  Blue is used for headline text and dominant shape fills, Navy is used
// for most text (and dark backgrounds), Sky is used for illustrating user interface, and Sky 20% is a background fill.
//
// Secondary palette: Green, Yellow, and Pink are decorative (illustrations, icons, callouts) and are supported by their
// tints Mint, Banana, and Bubble Gum.
export const shepherdColors = {
  blue: '#2878FD',
  navy: '#000F34',
  sky: '#B3E7F3',
  sky20: '#F0FAFD',
  green: '#49D69D',
  yellow: '#FAC641',
  pink: '#FF5981',
  mint: '#D0FDE4',
  banana: '#FCE8B3',
  bubbleGum: '#FFC5D3',
  white: '#FFFFFF'
};

// shepherdUiColors are shades derived from the brand palette for UI needs the brand guide doesn't cover (secondary
// text, hairlines, and an accessible destructive color).  They are kept separate so it's clear they are not part of
// the official palette.
export const shepherdUiColors = {
  // Navy at ~70% over white.  Used for secondary/supporting text (~7:1 contrast on white).
  navyMuted: '#4D5771',

  // Light, sky-tinted hairline for card and table borders.
  hairline: '#D5E4EE',

  // Stronger border for form inputs so they remain visible on white.
  inputBorder: '#AFC0CF',

  // The brand Pink is too light for text on white (~3:1), so destructive actions use a darkened Pink (~4.6:1).
  pinkDark: '#D6315A'
};

// shepherdTheme is the default theme for Shepherd Lens.
export const shepherdTheme: BrandingColors = {
  primary: shepherdColors.blue,
  onPrimary: shepherdColors.white,
  secondary: shepherdColors.navy,
  onSecondary: shepherdColors.white,
  destructive: shepherdUiColors.pinkDark,
  onDestructive: shepherdColors.white,
  accent: shepherdColors.sky,
  onAccent: shepherdColors.navy,
  widget: shepherdColors.white,
  onWidget: shepherdColors.navy,
  background: shepherdColors.sky20,
  onBackground: shepherdColors.navy,
  heading: shepherdColors.blue,
  muted: shepherdColors.sky20,
  mutedForeground: shepherdUiColors.navyMuted,
  border: shepherdUiColors.hairline,
  input: shepherdUiColors.inputBorder,
  ring: shepherdColors.blue,
  link: shepherdColors.blue,
  success: shepherdColors.green,
  onSuccess: shepherdColors.navy,
  warning: shepherdColors.yellow,
  onWarning: shepherdColors.navy,
  nav: shepherdColors.navy,
  onNav: shepherdColors.white
};
